import { useNavigationDrawerContext } from 'Views/Onboarding/Contexts/NavigationDrawerContext';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';

export default function useReviewItems(onClick) {
  const { isInitializing } = useNavigationDrawerContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  const handleClick = async () => {
    logStandardizedEvent(categories.clientDashboard, eventTypes.clickButton, 'review items');

    return onClick();
  };


  return {
    handleClick,
    isDisabled: isInitializing,
  };
}
